module.exports = Em.Handlebars.compile("{{#each item in items}}\n    {{download-list-item item=item}}\n{{/each}}\n");